import React from 'react'
import './herosection.css'
//import {Button} from '@mui/material'
import StepperSlider from './slider/StepperSlider'
import { Suspense } from 'react'
const Herosection = ({user,stores,slidesImages}) => {


  return (
    <div className='herocontainer'>
        { slidesImages && slidesImages.length > 0 ? <Suspense fallback={<div></div>}><StepperSlider user={user} stores={stores}images={slidesImages}/></Suspense> :""}
    
      </div>
  )
}

export default Herosection
